<script setup>
/* eslint-disable vue/no-v-html */
import { computed } from 'vue';
import SelectOptionV4 from '../../SelectOptionV4';
import { useMainStore } from '../../../store/index.js';
import { useWindowWidth } from '../../../composables/windowWidth.js';

const store = useMainStore();

const emit = defineEmits(['select']);

const props = defineProps({
  items: {
    type: Object,
    default: null,
  },
  images: {
    type: Object,
    required: true,
  },
  isSpecEB: {
    type: Boolean,
    required: true,
  },
  chassisDescriptionKey: {
    type: String,
    required: false,
    default: '',
  },
  showDimensionsSubheader: {
    type: Boolean,
    default: true,
  },
});

const { isSmall } = useWindowWidth(1000);

const chassisOptions = computed(() => {
  const groupSize = 2;
  const options = [];
  if (props.items) props.items.forEach((item) => options.push(item));
  return Array.from({ length: Math.ceil(options.length / groupSize) }, (_, i) => options.slice(i * groupSize, i * groupSize + groupSize));
});
</script>

<template>
  <section
    v-if="props.items"
    id="chassis"
    class="configurator-section"
  >
    <h2>{{ $i18n('chassisHeaderTitle') }}</h2>
    <h3
      v-if="props.showDimensionsSubheader && (props.images.side && props.images.isSide)"
    >
      {{ $i18n('dimensionsTitle') }}
    </h3>
    <div class="configurator-section__row configurator-section__image-container">
      <div
        v-if="props.images.side"
        class="configurator-section__image side-image-custom-margin"
      >
        <img
          :src="props.images.side"
          alt="Truck - side view"
        >
      </div>
      <div
        v-if="props.chassisDescriptionKey"
        class="configurator-section__image-text"
        v-html="$i18n(props.chassisDescriptionKey)"
      />
    </div>
    <template v-if="chassisOptions.length">
      <template
        v-for="(packageGroup, index) in chassisOptions"
        :key="index"
      >
        <div class="configurator-selection__options">
          <template
            v-for="(packageObject, index2) in packageGroup"
            :key="index2"
          >
            <SelectOptionV4
              v-for="option in packageObject.options"
              :key="option.id"
              :option="option"
              :selected="store.selected.chassis[packageObject.id]?.id == option.id"
              :show-description="true"
              :show-information="true"
              :single-option="packageObject.options?.length === 1"
              :style-object="isSmall ? { width: '420px' } : {}"
              @click="select(option)"
            />
          </template>
        </div>
      </template>
    </template>
  </section>
</template>

<style scoped>
.configurator-section__image {
  max-width: 70%;
}

.configurator-section__image>img {
  max-width: 100%;
  object-fit: cover;
}

.is-side-image-custom-margin,
.side-image-custom-margin {
  margin-top: -12rem;
}

.configurator-selection__options {
  gap: var(--sdds-spacing-layout-32);
}

@media only screen and (max-width: 1294px) {
  .configurator-section__image>img {
    height: initial;
  }

  .is-side-image-custom-margin,
  .side-image-custom-margin {
    margin-top: -10rem;
  }
}

@media only screen and (max-width: 1000px) {
  .configurator-section__image {
    width: 90%;
  }

  .configurator-section__row {
    flex-direction: column;
    align-items: center;
  }

  .configurator-selection__options {
    flex-direction: column;
    align-items: center;
    padding-bottom: var(--sdds-spacing-layout-8);
  }
}
</style>
